module.exports = __webpack_public_path__ + "img/device-manager.ab7e76e8.png";